import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, CardHeader, Dialog, IconButton, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { ProductCategory } from "@ploy-lib/rest-resources";
import { ProductView } from "@ploy-ui/form-views";
import { FormattedMessage } from "react-intl";
const FormattedHeaderText = (_jsx(FormattedMessage, { id: "vendor.wholesale.new-fulfillment-application-header", description: "New fulfillment application header", defaultMessage: "New withdrawal" }));
const useStyles = makeStyles((theme) => ({
    card: {
        overflow: "auto"
    },
    cardHeader: {
        color: theme.palette.secondary.main,
        fontWeight: "bold"
    }
}));
const WholesaleOverviewNewApp = (props) => {
    const { open, setOpen } = props;
    const classes = useStyles();
    return (_jsx(Dialog, { open: open, style: { margin: "auto" }, maxWidth: "md", children: _jsxs(Card, { className: classes.card, children: [_jsx(CardHeader, { titleTypographyProps: { className: classes.cardHeader }, title: FormattedHeaderText, action: _jsx(IconButton, { onClick: () => {
                            setOpen(false);
                        }, children: _jsx(CloseIcon, {}) }) }), _jsx(CardContent, { children: _jsx(ProductView, { externalCode: "BF_WHOLESALE", category: ProductCategory.Finance }) })] }) }));
};
export { WholesaleOverviewNewApp };
//# sourceMappingURL=WholesaleOverviewNewApp.js.map